module.exports = __webpack_public_path__ + "static/assets/17804258c5bf10434a225606640f1c7b.svg";